import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';
import API_BASE from '../../config';
import logo from '../../assets/logo.png';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        // Always show success to prevent account enumeration
        setSuccess(true);
      } else if (response.status === 429) {
        setError('Too many requests. Please wait a few minutes and try again.');
      } else {
        // Still show success for non-network errors to prevent enumeration
        setSuccess(true);
      }
    } catch (err) {
      setError('Unable to connect to the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <div className="auth-logo-div">
            <img src={logo} alt="Kigitz Logo" />
          </div>
          <p>Reset your password</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        {success ? (
          <div>
            <div className="info-message">
              If an account exists with that email, we've sent a password reset link. Please check your inbox and spam folder.
            </div>
            <div className="auth-link-center" style={{ marginTop: '16px' }}>
              <Link to="/login" className="auth-link">
                Back to Sign In
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="auth-link-center">
              <Link to="/login" className="auth-link">
                Back to Sign In
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
